import { useMemo } from 'react'

import {
  matchFilterNumber, sortArrayBy,
} from '@domain-group/javascript-utils'

import useSelector from '@hooks/useSelector'

import { useWatchEntityUpdates } from '@domain-group/react-hooks'

const watchEntityKeys = ['comments']

interface CommentFilters {
  commentable_id?: number,
  commentable_type?: string,
}

interface UseCommentsOptions {
  filters?: CommentFilters,
  performHttpRequests?: boolean,
}

function useComments(options: UseCommentsOptions = {}) {
  const { filters } = options
  const {
    commentable_id: filterCommentableId,
    commentable_type: filterCommentableType,
  } = filters || {}

  const {
    updatedEntities: { comments: commentsUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const comments = useSelector(reduxState => reduxState.entities.comments)

  const filteredComments = useMemo(() => {
    // Never return comments if commentable is not supplied
    if (!filterCommentableId || !filterCommentableType) return []

    const filtered = Object.values(comments).filter((comment) => {
      const { commentable_id, commentable_type } = comment

      const matchCommentableId = matchFilterNumber(commentable_id, filterCommentableId)
      const matchCommentableType = filterCommentableType ? commentable_type === filterCommentableType : true

      return matchCommentableId && matchCommentableType
    })

    return sortArrayBy(filtered, 'asc', 'id')
  }, [commentsUpdatedAt, JSON.stringify(filters)])

  const hasFilteredComments = !!filteredComments.length

  return {
    filteredComments,
    hasFilteredComments,
  }
}

export default useComments
